import { Button, Input, Popconfirm, Popover, Space, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { Text, View } from 'styles/reactnative'
import API from '../../../../utils/api'
import { useToken } from '../../../hooks'
import { CButton } from '../../../components/Common'
import { COLORS } from '../../../constants'
import { useNotification } from '../../../hooks/useNotification'
import { useFetcherPublic } from '../../../hooks/fetcher'
import BigNumber from 'bignumber.js'

const ActionButton = ({
	title,
	process,
	id,
	mutate = () => {},
	price = 0,
	type = 'W',
	data = {},
}: any) => {
	const { data: token } = useToken()
	const { refresh: notimutate } = useNotification()
	const [clicked, setClicked] = useState(false)

	const { data: sleepsetting } = useFetcherPublic('/system/sleepsetting')

	let sleepevent = false

	if (sleepsetting?.result?.result?.['GH_B:HON'] == 1) {
		sleepevent = true
	}

	// const { data: slp } = useFetcherPublic(
	// 	data?.user_id
	// 		? '/user/my/sleeppoint?testid=' +
	// 				data?.user_id +
	// 				'&date=' +
	// 				data?.created_at
	// 		: null
	// )

	let sleeppoint = new BigNumber(0)

	sleeppoint = BigNumber(Math.min(sleeppoint.toNumber(), price))

	const [amount, setAmount] = useState(
		price + (sleepevent ? sleeppoint.toNumber() : 0)
	)

	useEffect(() => {
		setAmount(price + (sleepevent ? sleeppoint.toNumber() : 0))
	}, [price])

	const saveProcess = () => {
		API.send(
			'PUT',
			'/admin/user/cash',
			token + '',
			{
				id,
				process,
			},
			false
		)
			.then(res => {
				if (res.result.success) {
					message.success('성공')
					mutate()
					notimutate()
				} else {
					message.error(res?.result?.message || '실패')
				}
			})
			.catch(err => {
				message.error('실패:' + err.message)
			})
	}

	const pay = () => {
		API.send(
			'POST',
			'/admin/user/cashsend',
			token + '',
			{
				id,
				type,
				amount,
			},
			false
		)
			.then(res => {
				if (res.result.success) {
					message.success('성공')
					mutate()
					notimutate()
				} else {
					message.error(res?.result?.message || '실패')
				}
			})
			.catch(err => {
				message.error('실패:' + err.message)
			})
		setClicked(false)
	}
	return (
		<>
			{process == 9 ? (
				<Popover
					trigger="click"
					open={clicked}
					placement="leftTop"
					title={
						<>
							{(type == 'W' ? '인출' : '지급') + ' 하시겠습니까?'}
							{type == 'D' && (
								<>
									<Text>
										요청 :{' '}
										{BigNumber(data?.amount)?.toFormat(0)}원
									</Text>

									{sleepevent && (
										<Text>
											휴면 :{' '}
											{BigNumber(sleeppoint)?.toFormat(0)}P
										</Text>
									)}
								</>
							)}
						</>
					}
					content={
						<Space.Compact>
							<Input
								value={amount}
								// onChange={e => {
								// 	setAmount(e.target.value)
								// }}
							/>
							<Button size="small" type="primary" onClick={pay}>
								{type == 'W' ? '인출승인' : '지급승인'}
							</Button>
							<Button
								size="small"
								onClick={() => setClicked(false)}>
								닫기
							</Button>
						</Space.Compact>
					}>
					<CButton
						title={title}
						onClick={() => {
							setClicked(true)
						}}
						style={{
							background:
								process == 9
									? COLORS.secondary
									: COLORS.darkRed,
							color: COLORS.white,
							fontSize: 11,
							padding: '5px 5px',
							marginRight: 5,
						}}
					/>
				</Popover>
			) : (
				<Popconfirm title="변경 하시겠습니까?" onConfirm={saveProcess}>
					<CButton
						title={title}
						style={{
							background:
								process == 2
									? COLORS.secondary
									: COLORS.darkRed,
							color: COLORS.white,
							fontSize: 11,
							padding: '5px 5px',
							marginRight: 5,
						}}
					/>
				</Popconfirm>
			)}
		</>
	)
}

export default React.memo(ActionButton)
